import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import scrollToComponent from 'react-scroll-to-component';

import {getJsonFromUrl} from '../../../../../utils/url';
import {cloneArray} from '../../../../../utils/data';
import {diamondImgUrl, diamondTitle, diamondPrice, settingCartDesc, diamondCartDesc} from '../../../../../utils/formatting';
import {getMetalTypeChildDropdownData, calcChildMetalMarkup, getMinPrice} from '../../../../../utils/product';

import {ringSizes} from '../../../../../constants/ringsizes';

import * as cartActionCreators from '../../../../../actions/cart';
import * as productActionCreators from '../../../../../actions/product';
let allActionCreators = Object.assign({}, cartActionCreators, productActionCreators);

import {FloatingHeaderContainer} from '../blocks/FloatingHeader';
import {SettingGridContainer} from './grids/SettingGrid';
import {DiamondGridContainer} from './grids/DiamondGrid';
import {CompareProductsContainer} from '../blocks/CompareProducts';

import RhinoSelect from '../../../../common/inputs/RhinoSelect';

class MixedResults extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let ringLabel = [
      {
        display: 'Size',
        value: '',
      }
    ];

    let urlData = getJsonFromUrl();

		this.state = {
      resultsDisplayType: urlData && urlData.tabtype && urlData.tabtype == 'setting' ? 'setting' : 'diamond',
      upperTabSelected: 'best',

      ringSizeData: ringLabel.concat(ringSizes),

      ringSize: this.props.product && this.props.product.attrSize ? this.props.product.attrSize : '',
      metalType: this.props.product && this.props.product.attrMetal ? this.props.product.attrMetal : '',
      validationMessage: '',

      metalPriceDiff: 0,

      hadTabUpdate: urlData && urlData.tabtype ? true : false,

      addingToCart: false,

      assembledOpen: true,

      openedClass: ' opened',
    };

    // console.log('this.state');
    // console.log(this.state);
	}

	componentDidMount() {

  }

  componentDidUpdate(prevProps, prevState) {

    if(this.props.tabValue != prevProps.tabValue) {
      if(this.props.tabValue != this.state.resultsDisplayType) {
        this.setState({ resultsDisplayType: this.props.tabValue });
      }
    }

    if(!this.state.hadTabUpdate) {
      this.setState({ 
        resultsDisplayType: this.props.tabValue,
        hadTabUpdate: true,
      });
    }
  }

  componentWillUnmount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getMetals() {
    if(!this.props.product.selectedSetting || !this.props.product.selectedSetting.price) {
      return [];
    }
    return getMetalTypeChildDropdownData(this.props.product.selectedSetting);
  }

  changeMetalType(evt) {
    this.setState({
      metalType: evt.target.value,
      validationMessage: '',
    }, () => {
      this.props.productSelectSetting(this.props.product.selectedSetting, this.state.metalType, this.props.product.attrSize);
    });
  }

  changeRingSize(evt) {
    this.setState({
      ringSize: evt.target.value,
      validationMessage: '',
    }, () => {
      this.props.productSelectSetting(this.props.product.selectedSetting, this.props.product.attrMetal, this.state.ringSize);
    });
  }

  selectDiamond(diamond) {
    this.props.productSelectDiamond(diamond);
    this.setState({ upperTabSelected: 'best' });
  }

  isDiamondSelected() {
    return this.props.product.selectedDiamond !== null;
  }

  selectSetting(product) {
    this.props.productSelectSetting(product);
    this.setState({ upperTabSelected: 'best' });
  }

  getProductMainImage(product) {
    if(product.image_count > 0) {
      return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
    }
  }

  isSettingSelected() {
    return this.props.product.selectedSetting !== null;
  }

  setResultsDisplayType(displayValue) {

    if(displayValue != this.state.resultsDisplayType) {
      this.props.productSetPage(1);
    }

    this.setState({ resultsDisplayType: displayValue });
  }

  selectUpperTab(tabVal) {
    this.setState({ upperTabSelected: tabVal });
  }

  getFavesLength() {
    if(this.state.resultsDisplayType == 'setting') {
      return this.props.product.compareSettings.length.toString();
    } else {
      return this.props.product.compareDiamonds.length.toString();
    }
  }

  getCombinedPrice() {
    if(this.props.product.selectedSetting && this.props.product.selectedDiamond) {
      return this.getProductPrice() + this.props.product.selectedDiamond.price;
    }
    return '';
  }

  getMetalKarat(setting) {
    if(!setting) {
      return 14;
    }
    let setVal = setting.karat;
    if(setting.attributes) {
      setVal = setting.attributes.karat;
    }
    if(!setVal) {
      setVal = 14;
    }
    return setVal;
  }

  scrollToSettings() {
    if(!this.settingControlRow) { return; }
    scrollToComponent(this.settingControlRow, {
      offset: -200, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  addToCart() {
    
    if(!this.state.metalType) {
      this.setState({validationMessage: 'Please select a metal type'});
      this.scrollToSettings();
      return;
    }

    if(!this.state.ringSize) {
      this.setState({validationMessage: 'Please select a ring size'});
      this.scrollToSettings();
      return;
    }

    let markup = parseInt(calcChildMetalMarkup(this.props.product.selectedSetting, this.state.metalType));
    let shapeString = this.props.product.selectedDiamond.shape;

    this.setState({ addingToCart: true });

    this.props.productFetchBySku(this.props.product.selectedSetting.sku)
    .then((respData) => {

      this.props.cartAddEngagementRing(this.props.product.selectedSetting.sku, this.state.metalType, this.state.ringSize, this.getMetalKarat(this.props.product.selectedSetting), parseInt(getMinPrice(this.props.product.selectedSetting)) + markup, this.props.product.selectedDiamond.stockNo, shapeString.toLowerCase().trim(), this.props.product.selectedDiamond.price, settingCartDesc(respData.success, this.state.metalType, this.state.ringSize), diamondCartDesc(this.props.product.selectedDiamond))
      .then((resp) => {
        console.log(resp);
        this.externalNav('checkout/cart');
      })
      .catch((errResp) => {
        this.setState({ addingToCart: false });
      });
    })
    .catch((errResp) => {
      this.setState({ addingToCart: false });
    });
  }

  getAssembledMessageContent() {
    if(!this.isDiamondSelected() && !this.isSettingSelected()) {
      return <div className='assembledMessage'>
        Choose a diamond or setting to start building your ring.
      </div>;
    } else if(!this.isDiamondSelected() && this.isSettingSelected()) {
      return <div className='assembledMessage'>
        Choose a diamond to complete your ring.
      </div>;
    } else if(this.isDiamondSelected() && !this.isSettingSelected()) {
      return <div className='assembledMessage'>
        Choose a setting to complete your ring.
      </div>;
    } else if(this.isDiamondSelected() && this.isSettingSelected()) {
      return <div className={'assembledInnerWrapper'}>
        <div className='assembledMessage fullRing'>
          {'Your ' + this.props.product.selectedSetting.name + ' with ' + this.props.product.selectedDiamond.caratWeight + ' carat ' + this.props.product.selectedDiamond.shape + ' diamond'}
        </div>
        <div className='assembledPrice'>${this.getCombinedPrice()}*</div>
        <div className='addToCartWrapper'>
          {this.state.addingToCart ?
            <div className={'addButton mixedResultsButton'}><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div> :
            <div className={'addButton mixedResultsButton'} onClick={::this.addToCart}>Add to Cart</div>
          }
        </div>
        <div className='assembledNotice'>*Total price may vary based on ring size or setting metal type.</div>
      </div>
    }
  }

  scrollToResults() {
    if(!this.resultsSection) { return; }
    scrollToComponent(this.resultsSection, {
      offset: -200, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  scrollDiamond() {
    this.scrollToResults();
    this.setState({ resultsDisplayType: 'diamond' });
  }

  scrollSetting() {
    this.scrollToResults();
    this.setState({ resultsDisplayType: 'setting' });
  }

  scrollTop() {
    scrollToComponent(this.topSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
    this.setState({ upperTabSelected: 'best' });
  }

  scrollCompare() {
    scrollToComponent(this.topSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
    this.setState({ upperTabSelected: 'picks' });
  }

  openFiltersScroll() {
    scrollToComponent(this.topSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
    this.props.openFilters();
  }

  getProductPrice() {
    if(!this.props.product.selectedSetting) {
      return '';
    }
    return parseInt(getMinPrice(this.props.product.selectedSetting)) + parseInt(calcChildMetalMarkup(this.props.product.selectedSetting, this.state.metalType));
    // return parseInt(this.props.product.selectedSetting.price);
  }

  toggleAssembled() {
    this.setState({
      assembledOpen: !this.state.assembledOpen,
      openedClass: '',
    }, () => {
      if(this.state.assembledOpen) {
        setTimeout(() => {
          this.setState({ openedClass: ' opened' });
        }, 500);
      }
    });
  }

	render() {

    const RESULT_LIMIT = 24;

    let pCount = 0;
    let dCount = 0;

		return <div className='MixedResults'>      
      
      <FloatingHeaderContainer 
        scrollTop={::this.scrollTop}
        scrollCompare={::this.scrollCompare}
        getFavesLength={::this.getFavesLength} />
			
      <div className='labelSection' ref={(div) => { this.topSection = div; }}>
        <div className='labelTitle' style={{display: 'none'}}>Build Your Ring</div>
        <div className='labelText' style={{display: 'none'}}>We've taken your search criteria and created a ring that matches your style and budget.</div>
      </div>
      <div className={this.state.assembledOpen ? `assembledWrapper open ${this.state.openedClass}` : 'assembledWrapper'}>
        <div className='assembledToggle' onClick={::this.toggleAssembled}>
          {this.state.assembledOpen ?
            <div className='assembledToggleIcon'>&mdash;</div> :
            <div className='assembledToggleIcon'>+</div>
          }
        </div>
        <div className={'assembledTabsWrapper desktopOnly'}>
          <div className={this.state.upperTabSelected == 'best' ? 'assembledTab selectedTab' : 'assembledTab'} onClick={() => this.selectUpperTab('best')}>Create Your Ring</div>
          <div className={this.state.upperTabSelected == 'picks' ? 'assembledTab selectedTab' : 'assembledTab'} onClick={() => this.selectUpperTab('picks')}>{this.state.resultsDisplayType == 'setting' ? 'Compare Settings' : 'Compare Diamonds'} ({this.getFavesLength()} of 4)</div>
        </div>
        <div className={'assembledTabsWrapper mobileOnly'}>
          <div className={this.state.upperTabSelected == 'best' ? 'assembledTab selectedTab' : 'assembledTab'} onClick={() => this.selectUpperTab('best')}>Your Ring</div>
          <div className={this.state.upperTabSelected == 'picks' ? 'assembledTab selectedTab' : 'assembledTab'} onClick={() => this.selectUpperTab('picks')}>Compare</div>
        </div>
        {this.state.upperTabSelected == 'best' ?
          <div className='assembledPreview'>
            <div className='assembledComponentWrapper'>
              <div className='assembledImageWrapper smallViews'>
                {this.getAssembledMessageContent()}
              </div>
              {this.isDiamondSelected() ?
                <div className='diamondComponentWrapper'>
                  <div className='diamondComponentImageWrapper'>
                    <img src={this.props.product.selectedDiamond.image} />
                  </div>
                  <div className='diamondComponentInfoWrapper'>
                    <div className='diamondInfoTitleRow'>
                      <span className='diamondInfoTitle'>{diamondTitle(this.props.product.selectedDiamond)}</span>
                      <span className='removeLink' onClick={() => this.props.productSelectDiamond(null)}>remove</span>
                    </div>
                    <div className='diamondInfoCustomRow'>
                      <div className='diamondInfoPrice'>${this.props.product.selectedDiamond.price.toLocaleString()}</div>
                      <div className='diamondInfoPriceNotice'>(diamond only)</div>
                    </div>
                    <div className='diamondInfoButtonRow'>
                      <div className={'assembledButton mixedResultsButton'} onClick={() => this.internalNav('diamond/' + this.props.product.selectedDiamond.id)}>View</div>
                    </div>
                  </div>
                </div> :
                <div className='diamondComponentWrapper nullElement'>
                  <div className={'diamondComponentNullWrapper nullElement'}>
                    <div className='diamondInfoTitleRow'>Browse diamonds to create your unique ring!</div>
                    <div className='scrollButton' onClick={::this.scrollDiamond}><div>Browse Diamonds</div></div>
                  </div>
                </div>
              }
              {this.isSettingSelected() ?
                <div className='settingComponentWrapper'>
                  <div className='settingComponentImageWrapper'>
                    <img src={this.getProductMainImage(this.props.product.selectedSetting)} />
                  </div>
                  <div className='settingComponentInfoWrapper'>
                    <div className='settingInfoTitleRow'>
                      <span className='settingInfoTitle'>{this.props.product.selectedSetting.name}</span>
                      <span className='removeLink' onClick={() => this.props.productSelectSetting(null)}>remove</span>
                    </div>
                    <div className='settingInfoCustomRow'>
                      <div className='settingInfoPrice'>${this.getProductPrice()}</div>
                      <div className='settingInfoPriceNotice'>(setting only)</div>
                    </div>
                    <div className='settingInfoButtonRow' ref={(div) => { this.settingControlRow = div; }}>
                      {this.state.validationMessage ? 
                        <div className='validationMessage'>{this.state.validationMessage}</div> :
                        null
                      }
                      <div className='dropdownWrapper'>
                        <RhinoSelect
                          options={this.getMetals()}
                          value={this.state.metalType}
                          changeMethod={::this.changeMetalType}
                          rootClass='resultsSelect' />
                      </div>
                      <div className='dropdownWrapper'>
                        <RhinoSelect
                          options={this.state.ringSizeData}
                          value={this.state.ringSize}
                          changeMethod={::this.changeRingSize}
                          rootClass='resultsSelect' />
                      </div>
                      <div className={'assembledButton mixedResultsButton'} onClick={() => this.internalNav('setting/' + this.props.product.selectedSetting.sku)}>View</div>
                    </div>
                  </div>
                </div> :
                <div className='settingComponentWrapper nullElement'>
                  <div className={'settingComponentNullWrapper nullElement'}>
                    <div className='settingInfoTitleRow'>Browse settings to create your unique ring!</div>
                    <div className='scrollButton' onClick={::this.scrollSetting}><div>Browse Settings</div></div>
                  </div>
                </div>
              }
            </div>
            <div className='assembledImageWrapper'>
              {this.getAssembledMessageContent()}
            </div>
          </div> :
          <CompareProductsContainer productType={this.state.resultsDisplayType} />
        }  
      </div>

      <div className='resultsWrapper' ref={(div) => { this.resultsSection = div; }}>
        <div className={'resultsTabWrapper desktopOnly'}>
          <div className={this.state.resultsDisplayType == 'diamond' ? 'resultTab selectedTab' : 'resultTab'} onClick={() => this.setResultsDisplayType('diamond')}>Diamond Results</div>
          <div className={this.state.resultsDisplayType == 'setting' ? 'resultTab selectedTab' : 'resultTab'} onClick={() => this.setResultsDisplayType('setting')}>Setting Results</div>          
        </div>
        <div className={'resultsTabWrapper mobileOnly'}>
          <div className={this.state.resultsDisplayType == 'diamond' ? 'resultTab selectedTab' : 'resultTab'} onClick={() => this.setResultsDisplayType('diamond')}>Diamonds</div>
          <div className={this.state.resultsDisplayType == 'setting' ? 'resultTab selectedTab' : 'resultTab'} onClick={() => this.setResultsDisplayType('setting')}>Settings</div>
        </div>
        <div className='resultsBody' ref={(div) => { this.resultsBody = div; }}>
          {this.state.resultsDisplayType == 'setting' ?
            <div className='bodyLabel' style={{display: 'none'}}>Choose a setting from the selection below to add to your selected ring:</div> :
            <div className='bodyLabel' style={{display: 'none'}}>Choose a diamond from the selection below to add to your selected ring:</div>
          }
          {this.state.resultsDisplayType == 'setting' ?
            <SettingGridContainer 
              updateMethod={::this.props.updateMethod} 
              scrollUp={::this.scrollToResults} 
              showSplashPage={::this.props.showSplashPage}
              openFilters={this.props.openFilters} /> :
            <DiamondGridContainer 
              updateMethod={::this.props.updateMethod} 
              scrollUp={::this.scrollToResults} 
              showSplashPage={::this.props.showSplashPage}
              openFilters={this.props.openFilters} />
          }
        </div>
      </div>


		</div>;
	}
}
export default MixedResults;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const MixedResultsContainer = connect(
  mapStateToProps,
  allActionCreators
)(MixedResults);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/results/MixedResults.jsx